import axios from "axios";
import MG from "metrics-graphics";
import $ from "jquery";

export default function (chart, divId, vizName) {
    var globals = {};

    var url = '/api/fetchData/' + chart.data.syspk + '/' + vizName

    console.log("Chart vizName called:", vizName)

    axios.get(url).then(res => {
        let data = res.data
        //   data = MG.convert.date(data, 'date','%Y-%m')
        data.map(function (d) {
            d.date = new Date(d.date);
        });
        /*
          var markers = [
               { "date": new Date("2020-08-02T18:30:00.000Z"), "label": "Week-32 FM" },
               { "date": new Date("2020-08-18T18:30:00.000Z"), "label": "Week-34 NM" },
               { "date": new Date("2020-09-01T18:30:00.000Z"), "label": "Week-36 FM" },
               { "date": new Date("2020-09-16T18:30:00.000Z"), "label": "Week-38 NM" }
          ]; */
        var markers = [
            {"date": new Date("2020-02-01T18:30:00.000Z"), "label": "M1"},
            {"date": new Date("2020-05-01T18:30:00.000Z"), "label": "M2"}
            //{ "date": new Date("2020-10-01T18:30:00.000Z"), "label": "M3" }//,
            //{ "date": new Date("2021-01-01T18:30:00.000Z"), "label": "M4" }
        ];

        var split_by_params = {
            title: "Order Count",
            description: "We sometimes have the need to split the data and then gracefully update the graphic with the newly selected subset of data.",
            width: chart.width / 2.2,
            height: chart.height / 1.2,
            right: chart.margin.right,
            target: "#split_by",
            markers: markers,
            x_accessor: 'date',
            y_accessor: 'metric1'
        };
        var modify_markers_params = {
            title: "Revenue",
            width: chart.width / 2.2,
            height: chart.height / 1.2,
            right: chart.margin.right,
            markers: markers,
            x_accessor: 'date',
            y_accessor: 'metric2',
            target: "#modify_markers"
        }
        var modify_time_period_params = {
            title: "Discount",
            width: chart.width / 2.2,
            height: chart.height / 1.2,
            right: chart.margin.right,
            markers: markers,
            x_accessor: 'date',
            y_accessor: 'metric3',
            target: "#modify_time_period"
        }
        globals.data = data;
        split_by_params.data = data;
        MG.data_graphic(split_by_params);
        modify_markers_params.data = data;
        MG.data_graphic(modify_markers_params);
        modify_time_period_params.data = data;
        MG.data_graphic(modify_time_period_params);

        $('.split-by-controls button').click(function () {
            var past_n_days = $(this).data('time_period');
            var data = modify_time_period(globals.data, past_n_days);

            // change button state
            $(this).addClass('active').siblings().removeClass('active');

            delete split_by_params.xax_format;
            split_by_params.data = data;
            MG.data_graphic(split_by_params);
        });

        $('.split-by-controls button').click(function () {
            var past_n_days = $(this).data('time_period');
            var data = modify_time_period(globals.data, past_n_days);

            // change button state
            $(this).addClass('active').siblings().removeClass('active');

            delete modify_markers_params.xax_format;
            modify_markers_params.data = data;
            MG.data_graphic(modify_markers_params);
        });
        $('.split-by-controls button').click(function () {
            var past_n_days = $(this).data('time_period');
            var data = modify_time_period(globals.data, past_n_days);

            // change button state
            $(this).addClass('active').siblings().removeClass('active');

            delete modify_time_period_params.xax_format;
            modify_time_period_params.data = data;
            MG.data_graphic(modify_time_period_params);
        });

        function modify_time_period(data, past_n_days) {
            if (past_n_days !== '') {
                return MG.clone(data).slice(past_n_days * -1);
            }
            return data;
        }
    })
}
